// components/onboarding/OnboardingWelcomeModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOnboarding } from '../../context/OnboardingContext';
import { PiDog } from 'react-icons/pi';
import { FiCalendar, FiUser, FiArrowRight, FiX } from 'react-icons/fi';
import '../../styles/Onboarding.css';

/**
 * OnboardingWelcomeModal
 *
 * Initial modal shown to first-time users asking if they want
 * to take a guided tour of the application.
 */
const OnboardingWelcomeModal = () => {
    const { t } = useTranslation(['onboarding', 'common']);
    const { showWelcomeModal, startOnboarding, skipOnboarding } = useOnboarding();

    if (!showWelcomeModal) {
        return null;
    }

    return (
        <div className="onboarding-modal-overlay">
            <div className="onboarding-welcome-modal">
                {/* Close button */}
                <button
                    className="onboarding-close-btn"
                    onClick={skipOnboarding}
                    title={t('common:close')}
                    aria-label={t('common:close')}
                >
                    <FiX />
                </button>

                {/* Header */}
                <div className="onboarding-welcome-header">
                    <div className="onboarding-welcome-icon">
                        <PiDog />
                    </div>
                    <h2>{t('onboarding:welcomeModal.title')}</h2>
                    <p className="onboarding-welcome-subtitle">
                        {t('onboarding:welcomeModal.subtitle')}
                    </p>
                </div>

                {/* Body */}
                <div className="onboarding-welcome-body">
                    <p className="onboarding-welcome-message">
                        {t('onboarding:welcomeModal.message')}
                    </p>

                    <div className="onboarding-features-preview">
                        <h4>{t('onboarding:welcomeModal.whatYouLearn')}</h4>
                        <ul>
                            <li>
                                <span className="feature-icon"><PiDog /></span>
                                <span>{t('onboarding:welcomeModal.addDog')}</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiCalendar /></span>
                                <span>{t('onboarding:welcomeModal.bookTrainings')}</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiUser /></span>
                                <span>{t('onboarding:welcomeModal.manageAccount')}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Actions */}
                <div className="onboarding-welcome-actions">
                    <button
                        className="onboarding-btn onboarding-btn-primary"
                        onClick={startOnboarding}
                    >
                        {t('onboarding:welcomeModal.startGuide')}
                        <FiArrowRight />
                    </button>
                    <button
                        className="onboarding-btn onboarding-btn-secondary"
                        onClick={skipOnboarding}
                    >
                        {t('onboarding:welcomeModal.skip')}
                    </button>
                </div>

                {/* Footer note */}
                <p className="onboarding-welcome-footer">
                    {t('onboarding:welcomeModal.footer')}
                </p>
            </div>
        </div>
    );
};

export default OnboardingWelcomeModal;
